module.exports = __webpack_public_path__ + "static/img/cabecera2.b795d3f2.jpg";